import $ from "jquery";
import TrackingConsent from "./TrackingConsent";

var FacebookPixelAdapter = function () {
  this.pixelIds = [];

  // ============================================================
  this.register = function () {
    $(".js_tracking_fb_container").each((_, el) => {
      if (!this.pixelIds.includes($(el).data("id"))) {
        this.pixelIds.push($(el).data("id"));
      }
      $(el).remove();
    });
  };

  // ============================================================
  this.pageView = function (params = {}) {
    if (!this.pixelIds.length || typeof fbq === "undefined") return;

    TrackingConsent.setGtagConsent();

    this.pixelIds.forEach((id) => {
      fbq("track", "PageView", params);
    });
  };

  // ============================================================
  this.event = function (eventName, params = {}) {
    if (!this.pixelIds.length || typeof fbq === "undefined") return;

    TrackingConsent.setGtagConsent();

    this.pixelIds.forEach((id) => {
      fbq("track", eventName, params);
    });
  };
};

export default FacebookPixelAdapter;
